import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <div>
            <footer>
                <div className="container">
                    <p>Develop by Shemul</p>
                </div>
            </footer>
        </div>
    );
};

export default Footer;